<template>
  <HotelImageProvider
    :static-images="staticImages"
    :giata-id="package.giata_id"
    :package="package"
    :style="{ aspectRatio }"
  >
    <template #default="{ hotelImages, fallbackImages, loading }">
      <div class="image-container absolute top-0 left-0 size-full">
        <HeaderImageCarousel
          :package="package"
          :display-images="hotelImages.length > 0 ? hotelImages : fallbackImages"
          :loading="loading"
          :nested="nestedSlider"
          @slide-change="handleSlideChange"
        />
      </div>
      <div class="image-top-left z-[1]">
        <div class="flex flex-col">
          <CampaignTag
            v-for="tag in filterTags('image-top-left')"
            :key="`tag-${tag.id}`"
            class="mb-2"
            :tag="tag"
            :show-icon="true"
          />
        </div>
      </div>
      <div
        v-if="allowGallery"
        class="image-bottom-right z-[1]"
      >
        <LazyExpandGalleryButton
          :package="package"
          :btn-class="'btn-gallery'"
          :initial-slide="initialGallerySlide"
          :display-images="hotelImages.length ? hotelImages : fallbackImages"
          :loading="loading"
        />
      </div>
    </template>
  </HotelImageProvider>
</template>

<script>
export default defineNuxtComponent({
  name: 'HotelPackageCardHeader',

  props: {
    package: {
      type: Object,
      required: true,
    },

    staticImages: {
      type: Boolean,
      default: false,
    },

    allowGallery: {
      type: Boolean,
      default: true,
    },

    aspectRatio: {
      type: String,
      default: '4/3',
    },

    nestedSlider: {
      type: Boolean,
      default: false,
    },

    currentCharterTag: {
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      initialGallerySlide: 0,
    }
  },

  methods: {
    handleSlideChange (currentSlide) {
      this.initialGallerySlide = currentSlide
    },

    filterTags (position) {
      if (this.currentCharterTag && this.currentCharterTag.position === position) {
        return this.package.charter_tags.filter(tag => tag && tag.id === this.currentCharterTag.id)
      }

      return (this.package?.charter_tags || []).filter(tag => tag && tag.position === position)
    },
  },
})
</script>

<style lang="scss" scoped>
.aspect-ratio-4-3 {
  width: 100%;
  padding-top: 75%;
  position: relative;
  overflow: hidden;
}
.aspect-ratio-4-3:hover :deep(.btn-gallery) {
  @media (min-width: theme('screens.md')) {
    opacity: 1;
  }
}
.image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.image-top-left {
  position: absolute;
  top: 1.3rem;
  left: 0;
}

.image-bottom-right {
  position: absolute;
  bottom: 0.8rem;
  right: 0.8rem;
}

:deep(.btn-gallery) {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  @media (max-width: theme('screens.md')) {
    display: none;
  }
}
</style>
